
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { LocaleProvider } from 'antd';
import { IntlProvider } from 'react-intl';
import App from './containers/App/App';
import AppIframe from './containers/App/AppIFrame';
import { ThemeProvider } from 'styled-components';
import asyncComponent from './helpers/AsyncFunc';
import AppLocale from './languageProvider';
import themes from './config/themes';
import AppConfig from './config/AppConfig';
import DashAppHolder from './dashAppStyle';
import SagaAuthRedux from './redux/sagaAuth/sagaAuthRedux';
import { store } from './redux/store';
import { decrypt, getCurrentPath, getDocumentRoot, isRenderAsIFrame } from './helpers/utility';
import queryString from 'query-string';

const tag = '[ROUTER]';
const RestrictedRoute = ({
    component: Component,
    isLoggedIn,
    locale,
    office,
    returnUrl,
    ...rest
}) => {
    return (
        <Route
            {...rest} z
            render={(props) => {

                // console.log(tag + ' ' + 'PROP >>', props);
                // console.log(tag + ' ' + 'returnUrl >>', returnUrl);
                //
                // console.log(`${tag} Restricted path `, props.location, ' called, current login status is : ', isLoggedIn, ' locale is : ', locale);
                return isLoggedIn
                    ? <Component {...props} />
                    : <Redirect
                        to={{
                            pathname: `/${office}/${locale}/signin`,
                            state: {
                                from: props.location
                            }
                        }} />;
            }} />
    );
};

const PublicRoutes = ({ history, isLoggedIn, startupComplete, language, currentOffice, router, loginFetching, username, password, location, officeId }) => {
    const locale = language && language.locale ? language.locale : AppConfig.defaultLanguage;
    const office = currentOffice ? currentOffice.officeName.toLowerCase() : 'default';
    const currentAppLocale = AppLocale[locale];

    let pathFromRouter = '';
    if (router && router.location) {
        pathFromRouter = router.location.pathname;
    }

    const parseVal = queryString.parse(getCurrentPath());
    let userNameFromQuery;
    let passwordFromQuery;
    let officeIdFromQuery;
    if (parseVal && parseVal.token) { // @TON: Make sure the token is URL Encoded.
        const token = decrypt(parseVal.token); // softverk|King354.|10000000-0000-0000-0000-000000000000|129 ( username|password|userId|officeId )
        if (token && token.indexOf('|') > 0) {
            const tokenSplit = token.split('|');
            userNameFromQuery = tokenSplit[0];
            passwordFromQuery = tokenSplit[1];
            officeIdFromQuery = tokenSplit[2];
        }
    }

    let useIframe = router && router.location && router.location.search && router.location.search.indexOf('iframe') !== -1;
    // if render as iframe should display without UI menu
    if(isRenderAsIFrame()) { useIframe = true; }

    if (startupComplete &&
        userNameFromQuery &&
        passwordFromQuery &&
        useIframe &&
        officeIdFromQuery &&
        (userNameFromQuery !== username || passwordFromQuery !== password || +officeIdFromQuery !== +officeId)
    ) {
        store.dispatch(SagaAuthRedux.requestLogin(userNameFromQuery, passwordFromQuery, location, officeIdFromQuery));
        loginFetching = true; // override what is coming from router because we want to force showing "Starting.."
    }

    let loadComplete = startupComplete;
    if (useIframe) { // if in iframe, *DO NOT SHOW LOGIN SCREEN EVER*, should go directly to designated location..
        if (loginFetching) {
            loadComplete = false;
        }
    }

    return (
        (currentAppLocale && currentOffice) ?
            <LocaleProvider locale={currentAppLocale.antd}>
                <IntlProvider
                    locale={currentAppLocale.locale}
                    messages={currentAppLocale.messages}>
                    <ThemeProvider theme={themes[AppConfig.themeConfig.theme]}>
                        <DashAppHolder>
                            <ConnectedRouter history={history}>
                                {loadComplete ? <div>
                                    <Route
                                        exact
                                        path={'/'}
                                        render={() => <Redirect
                                            to={{
                                                pathname: `/${office}/${locale}/signin`
                                            }}
                                        />} />
                                    <Route
                                        exact
                                        path={'/signin'}
                                        render={() => <Redirect
                                            to={{
                                                pathname: `/${office}/${locale}/signin`
                                            }}
                                        />} />


                                    <Route
                                        exact
                                        path={'/:officeName/:lang/signin'}
                                        component={asyncComponent(() => import('./containers/Page/signin'))} />


                                    <RestrictedRoute path={'/:officeName/:lang/dashboard'}
                                        component={useIframe ? AppIframe : App}
                                        isLoggedIn={isLoggedIn}
                                        locale={locale}
                                        office={office}
                                        returnUrl={location}
                                    />

                                </div> : <div>Loading...</div>}
                            </ConnectedRouter>
                        </DashAppHolder>
                    </ThemeProvider>
                </IntlProvider>
            </LocaleProvider> : null
    );
};

export default connect(
    state => {
        return ({
            isLoggedIn: state.SagaAuth.loginResponse !== null,
            startupComplete: state.Volatile.startupComplete,
            language: state.Language.language,
            currentOffice: state.SagaAuth.currentOffice,
            router: state.router,
            loginFetching: state.SagaAuth.loginFetching,
            username: state.SagaAuth.username,
            password: state.SagaAuth.password,
            location: state.SagaAuth.returnUrl ? state.SagaAuth.returnUrl : state.router.location,
            officeId: state.SagaAuth.currentOffice ? state.SagaAuth.currentOffice.id : null
        });
    })(PublicRoutes);



// WEBPACK FOOTER //
// ./src/router.tsx